import { InputEventTypes } from '../enums';

const InputErrorHandler = {
  methods: {
    handleErrorChange(value, validators) {
      const [errorObject] = validators
        .map((validator) => validator(value))
        .filter((validatorOptions) => validatorOptions.isError);

      if (!errorObject) {
        this.$emit(InputEventTypes.ErrorChange, { isError: false });

        return;
      }

      const { errorMessage, isError } = errorObject;

      this.$emit(InputEventTypes.ErrorChange, { errorMessage, isError });
    },
  },
};

export default InputErrorHandler;
